import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BRAND_EDIT, BRAND_VIEW_TAB_LIST } from '../../../../constants/PropertyConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_BRANDS,
} from '../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { allBrandsSelector, allHotelsSelector } from '../../propertySlice';
import MediaViewer from '../../../../shared/media-viewer/MediaViewer';
import { decodeMediaKeyValue } from '../../../../utils/mediaUtils';

const BrandView = (props) => {
  const { brand, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedBrand, setSelectedBrand] = useState(brand);
  const originalBrands = useSelector(allBrandsSelector);
  const originalHotels = useSelector(allHotelsSelector);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const brandObj = {
      ...originalBrands.find((tempBrand) => tempBrand.id === brand.id),
    };
    brandObj['hotels'] = originalHotels.filter((b) => b.brandId === brand.id);
    setSelectedBrand(brandObj);
  }, [originalBrands]);

  const getHotels = (hotels) => {
    let hotelList = hotels.map((hotel) => {
      return hotel.name;
    });
    return hotelList.sort().join(', ');
  };

  const onClickEdit = (event) => {
    toggleDrawer(BRAND_EDIT, true, selectedBrand);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12 mb-4'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Brand Name</div>
                <div className='details-value'>{selectedBrand.name}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Brand Code</div>
                <div className='details-value'>{selectedBrand.code}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {selectedBrand.description ? selectedBrand.description : '---'}
                </div>
              </div>
            </div>

            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>No.of Hotels</div>
                <div className='details-value'>{selectedBrand.hotels?.length || 0}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Hotel names</div>
                <div className='details-value'>
                  {selectedBrand.hotels?.length ? getHotels(selectedBrand.hotels) : '---'}
                </div>
              </div>
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row pt-4'>
            <MediaViewer
              images={selectedBrand?.images || []}
              videos={(() => {
                const { Video: videoMediaContent } = decodeMediaKeyValue(
                  selectedBrand?.mediaContent,
                );
                return videoMediaContent || selectedBrand?.videos || {};
              })()}
              gifs={(() => {
                const { GIF: gifMediaContent } = decodeMediaKeyValue(selectedBrand?.mediaContent);
                return gifMediaContent || selectedBrand?.gifs || {};
              })()}
            />
          </div>
        )}
        {tabValue === 2 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={brand?.images || []}
              videos={(() => {
                const { Video: videoMediaContent } = decodeMediaKeyValue(brand?.mediaContent);
                return videoMediaContent || brand?.videos || {};
              })()}
              gifs={(() => {
                const { GIF: gifMediaContent } = decodeMediaKeyValue(brand?.mediaContent);
                return gifMediaContent || brand?.gifs || {};
              })()}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedBrand && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={BRAND_VIEW_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedBrand.name}
          createdUserId={selectedBrand.createdBy}
          isEditable={permissions[RBAC_TYPE_BRANDS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-4'
          isHeightIncluded={true}
        />
      )}
    </>
  );
};

export default BrandView;
